
import DateRangeSlider from "@/components/DateRangeSlider.vue";
import Diagram, { DiagramData } from "@/components/Diagram.vue";
import DiagramTableSwitch from "@/components/DiagramTableSwitch.vue";
import Loader from "@/components/Loader.vue";
import Table, { Column } from "@/components/Table.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { WSWasserstand } from "../interfaces";
import { wasserstandService } from "../service";
import PrintButton from "@/components/PrintButton.vue";

@Component({
  components: {
    Table,
    DiagramTableSwitch,
    Diagram,
    Loader,
    DateRangeSlider,
    PrintButton
  }
})
export default class Wasserstaende extends Vue {
  @Prop({ required: true })
  id!: number;

  wasserstaendeTableMeta: Column[] = [
    { text: "Datum", key: "cleardate" },
    { text: "Uhrzeit", key: "time" },
    { text: "Wasserstand in cm (ungeprüfte Rohdaten)", key: "wasserstand" }
  ];
  hwmdUrl = null;

  wasserstaende: Array<WSWasserstand> | null = null;

  uniqueDateWasserstaende: Array<WSWasserstand> = [];

  filteredWasserstaende: Array<WSWasserstand> = [];

  items = ["Anzeige als Ganglinie", "Anzeige als Liste"];

  dateRange: (Date | null)[] = [null, null];

  tabs = null;

  beforeMount() {
    this.getWasserstaende(this.id);
  }

  @Watch("dateRange")
  updateFilteredAbflusswerte(event) {
    this.filteredWasserstaende = [];

    const startDate = event[0];
    const endDate = event[1];

    if (startDate && endDate) {
      startDate.setHours(0);
      startDate.setMinutes(0);
      endDate.setHours(23);
      endDate.setMinutes(59);
    }

    if (event && startDate && endDate) {
      const items = this.wasserstaende?.filter(item => {
        if (item.parseddate) {
          return item.parseddate >= startDate && item.parseddate <= endDate;
        }
      });
      Object.assign(this.filteredWasserstaende, items);
    }
  }

  removeDuplicates(wasserstaende: WSWasserstand[]) {
    const unique: any[] = [];
    const uniqueObject = {};
    for (const i in wasserstaende) {
      const objDate = wasserstaende[i].cleardate;
      uniqueObject[objDate] = wasserstaende[i];
    }
    for (const i in uniqueObject) {
      unique.push(uniqueObject[i]);
    }
    return unique;
  }

  getDiagramData(): DiagramData {
    const diagramData = {
      legendText: "Messwerte Wasserstand (ungeprüfte Rohdaten)",
      list: [{ xValue: 0, yValue: 0.0 }],
      xUnit: "",
      yUnit: "W in cm"
    };

    this.filteredWasserstaende.map(wasserstandElement => {
      try {
        diagramData.list.push({
          xValue: Date.parse(wasserstandElement.datestring),
          yValue: parseFloat(wasserstandElement.wasserstand)
        });
      } catch (ex) {
        console.error(ex);
      }
    });

    diagramData.list.shift();
    return diagramData;
  }

  parseDates(ws: WSWasserstand): Date {
    return new Date(ws.datestring);
  }

  xaxisformatterTooltip(xValue: number) {
    return new Date(xValue).toLocaleString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  }

  getWasserstaende(ms_nr: number) {
    wasserstandService
      .getWasserstaende(ms_nr)
      .then(response => {
        const wasserstaendeInit = response.data;

        wasserstaendeInit.forEach(element => {
          element.parseddate = this.parseDates(element);
        });

        this.wasserstaende = wasserstaendeInit;
        this.filteredWasserstaende = wasserstaendeInit;

        this.uniqueDateWasserstaende = this.removeDuplicates(wasserstaendeInit);

        this.getDiagramData();
      })
      .catch(e => {
        console.error(e);
      });
  }

  onLoadedWasserstandStammdaten(data) {
    if (data) {
      this.hwmdUrl = data[0].hwmd_url;
    }
  }
}

// TODO CHECK DFue == 1 (STAMMDATEN)
